function Resume() {
  return (
    <section id="contact">
      <h2>RESUME PAGE</h2>
      <p>Email: your@email.com</p>
    </section>
  );
}

export default Resume;